import { restApiClient } from '@/datasources';

interface GetPromotionSalesStatusResponse {
  budgetIsCloseToEnd: boolean;
  salesLimitIsCloseToEnd: boolean;
}

export async function getPromotionSalesStatusService(promotionId: string): Promise<GetPromotionSalesStatusResponse> {
  const { data } = await restApiClient.get<GetPromotionSalesStatusResponse>(
    `/online/promotions/${promotionId}/sales-status/`,
  );

  return data;
}
